export default __webpack_public_path__ + "static/media/Major Rune Stone of the Silent Slayer.237f42d1.jpg";